import React from 'react';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-17" data-mp="pkheu03czkg0">
      <div className="mx-auto max-w-3xl" data-id="element-18" data-mp="pm2eu58fzvl9">
        <div className="text-center" data-id="element-19" data-mp="avv3sakrleul">
          <span className="inline-block rounded-full bg-brand px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-20" data-mp="autfh4eqmvux">
            Empfohlen
          </span>
          <h2 className="mt-4 font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-21" data-mp="1tlu1mxblpi9">
            5 exklusive Boni
          </h2>
          <p className="mt-2 text-sm text-ink/60" data-id="element-22" data-mp="3o24w6539q3vw">
            Im Wert von <span className="font-bold text-amber-600 line-through" data-id="element-23" data-mp="3o3pum5spe6z1">{BONUS_TOTAL}</span> —{' '}
            <span className="font-bold text-brand" data-id="element-24" data-mp="3t2smeojoagp2">gratis für dich.</span>
          </p>
        </div>

        <ol className="mt-9 space-y-4" data-id="element-25" data-mp="1m85lnlxyzqk9">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex flex-col gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(20,17,15,0.06)] sm:flex-row sm:items-center sm:gap-5" data-id="element-26" data-mp="1r8jw1an1nclg" data-mpi={index}>
              <div className="flex items-center gap-4" data-id="element-27" data-mp="3dd91pac1fhwt">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-28" data-mp="3r5ovdkj1u3l2">
                  {index + 1}
                </span>
                <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" className="h-44 w-36 shrink-0 object-contain mix-blend-multiply sm:h-52 sm:w-44" data-id="element-29" data-mp="2zglpk0bikl6b" />
              </div>
              <div className="min-w-0" data-id="element-30" data-mp="33hff0y4lu81b">
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-31" data-mp="33ge3ytnl9ljl">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-32" data-mp="nruj0hsa7t20">{bonus.text}</p>
                <p className="mt-3 text-xs font-bold" data-id="element-33" data-mp="it154o93201b">
                  <span className="text-ink/50" data-id="element-34" data-mp="3cjpsvc949iuf">Wert </span>
                  <span className="text-amber-600 line-through" data-id="element-35" data-mp="3cl99j3yopvwq">{bonus.was}</span>{' '}
                  <span className="text-brand" data-id="element-36" data-mp="3hk3yknn8wgpa">— GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}